import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HealthInsurance from "../pages/service/HealthInsurance";
import TermInsurance from "../pages/service/TermInsurance";
import LifeInsurance from "../pages/service/LifeInsurance";
import CarInsurance from "../pages/service/CarInsurance";
import TravelInsurance from "../pages/service/TravelInsurance";
import MarineInsurance from "../pages/service/MarineInsurance";
import CorporateInsurance from "../pages/service/CorporateInsurance";
import GroupHealthInsurance from "../pages/service/GroupHealthInsurance";
import MutualFunds from "../pages/service/MutualFunds";
import SIPInvestments from "../pages/service/SIPInvestments";
import RetirementPlanning from "../pages/service/RetirementPlanning";
import FinancialPlanning from "../pages/service/FinancialPlanning";
import ComparePlans from "../pages/compare/page";
import Calculators from "../pages/calculators/page";
import SIPCalculator from "../pages/calculator/SIPCalculator";
import HealthCalculator from "../pages/calculator/HealthCalculator";
import TermCalculator from "../pages/calculator/TermCalculator";
import RetirementCalculator from "../pages/calculator/RetirementCalculator";
import ChildEducationCalculator from "../pages/calculator/ChildEducationCalculator";
import HLVCalculator from "../pages/calculator/HLVCalculator";
import NeedAnalysisCalculator from "../pages/calculator/NeedAnalysisCalculator";
import BookAppointment from "../pages/book-appointment/page";
import Contact from "../pages/contact/page";
import ClaimsAssistance from "../pages/claims-assistance/page";
import About from "../pages/about/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Terms from "../pages/terms/page";
import CityPage from "../pages/cities/page";
import HealthInsuranceCompanies from "../pages/health-insurance-companies/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminLeads from "../pages/admin/leads/page";
import AdminAppointments from "../pages/admin/appointments/page";
import AdminSettings from "../pages/admin/settings/page";
import AdminBrochures from "../pages/admin/brochures/page";
import AdminSetup from "../pages/admin/setup/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/health-insurance",
    element: <HealthInsurance />,
  },
  {
    path: "/term-insurance",
    element: <TermInsurance />,
  },
  {
    path: "/life-insurance",
    element: <LifeInsurance />,
  },
  {
    path: "/car-insurance",
    element: <CarInsurance />,
  },
  {
    path: "/travel-insurance",
    element: <TravelInsurance />,
  },
  {
    path: "/marine-insurance",
    element: <MarineInsurance />,
  },
  {
    path: "/corporate-insurance",
    element: <CorporateInsurance />,
  },
  {
    path: "/group-health-insurance",
    element: <GroupHealthInsurance />,
  },
  {
    path: "/mutual-funds",
    element: <MutualFunds />,
  },
  {
    path: "/sip-investments",
    element: <SIPInvestments />,
  },
  {
    path: "/retirement-planning",
    element: <RetirementPlanning />,
  },
  {
    path: "/financial-planning",
    element: <FinancialPlanning />,
  },
  {
    path: "/compare-plans",
    element: <ComparePlans />,
  },
  {
    path: "/calculators",
    element: <Calculators />,
  },
  {
    path: "/calculator/sip",
    element: <SIPCalculator />,
  },
  {
    path: "/calculator/health",
    element: <HealthCalculator />,
  },
  {
    path: "/calculator/term",
    element: <TermCalculator />,
  },
  {
    path: "/calculator/retirement",
    element: <RetirementCalculator />,
  },
  {
    path: "/calculator/child-education",
    element: <ChildEducationCalculator />,
  },
  {
    path: "/calculator/hlv",
    element: <HLVCalculator />,
  },
  {
    path: "/calculator/need-analysis",
    element: <NeedAnalysisCalculator />,
  },
  {
    path: "/book-appointment",
    element: <BookAppointment />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/claims-assistance",
    element: <ClaimsAssistance />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/health-insurance-companies",
    element: <HealthInsuranceCompanies />,
  },
  {
    path: "/cities/:city",
    element: <CityPage />,
  },
  {
    path: "/admin-setup",
    element: <AdminSetup />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute requireAdmin>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/leads",
    element: (
      <ProtectedRoute requireAdmin>
        <AdminLeads />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/appointments",
    element: (
      <ProtectedRoute requireAdmin>
        <AdminAppointments />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/settings",
    element: (
      <ProtectedRoute requireAdmin>
        <AdminSettings />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/brochures",
    element: (
      <ProtectedRoute requireAdmin>
        <AdminBrochures />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;